export enum MapType {
  'grundstueck' = 'grundstueck',
  'gemeinde' = 'gemeinde',
  'DIENSTBARKEIT' = 'DIENSTBARKEIT',
  'VORMERKUNG' = 'VORMERKUNG',
  'oereb' = 'oereb',
  'eigentum' = 'eigentum'
}
